import { extractContentsFromResponse } from "shared/api";

export function defaultInitialState() {
  return {};
}

export function defaultReceiveSuccessState(state, action, resourceNames = []) {
  var newState = {};
  const stateChanges = extractContentsFromResponse(
    action.payload,
    resourceNames,
  );
  Object.entries(stateChanges).forEach(entry => {
    const [resourceName, resourceData] = entry;

    newState[resourceName] = {
      ...state[resourceName],
      ...resourceData,
    };
  });

  return newState;
}
